import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { createDashboardHierarchyFolderThunkFixedCacheKey } from "../../thunks/dashboard-hierarchy/createDashboardHierarchyFolderThunk";

export const createDashboardFolderSelector =
  cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentDashboardFolders.select(
    createDashboardHierarchyFolderThunkFixedCacheKey,
  );
